import React from 'react';
import Modal from 'react-modal';

import swal from 'sweetalert';

export default class TramerModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,

      damageHistory: {
        queryDate: this.props.defaultValue && this.formatDateForInput(this.props.defaultValue.queryDate) || '',
        amount: this.props.defaultValue && this.props.defaultValue.amount || 0,
        date: this.props.defaultValue && this.formatDateForInput(this.props.defaultValue.date) || '',
        comment: this.props.defaultValue && this.props.defaultValue.comment || ''
      },
    };
  }

  componentDidMount() {
  }
  
  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.saveOnClick(this.state.damageHistory);
      event.preventDefault();
    }
  }

  formatDateForInput(dateStr) {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toISOString().split('T')[0];
  }

  saveOnClick() {
    let infoMessage = '';
    
    const rawAmount = (this.state.damageHistory.amount === '' || this.state.damageHistory.amount === null || this.state.damageHistory.amount === undefined) ? '0' : this.state.damageHistory.amount.toString();
    const cleanedAmountStr = rawAmount.replace(/\./g, '').replace(',', '.');
    const cleanedAmount = parseFloat(cleanedAmountStr);

    if (this.state.damageHistory.date === '') {
      infoMessage = 'Tarih boş geçilemez !';
    } else if (this.state.damageHistory.comment === '') {
      infoMessage = 'Açıklama boş geçilemez !';
    }

    if (infoMessage) {
      swal({
        dangerMode: true,
        icon: 'info',
        title: 'Eksik Bilgi',
        text: infoMessage,
        buttons: 'Tamam'
      });
    } else {
      const isoDate = new Date(this.state.damageHistory.date).toISOString();
      const isoQueryDate = new Date(this.state.damageHistory.queryDate).toISOString();
      const newDamageHistory = {
        amount: cleanedAmount,
        date: isoDate,
        queryDate: isoQueryDate,
        comment: this.state.damageHistory.comment
      };
      this.props.saveOnClick(newDamageHistory);
      this.setState({damageHistory: { amount: cleanedAmount, date: isoDate, queryDate: isoQueryDate, comment: this.state.damageHistory.comment}});
    }
  }
  
  render() {
    return (
      <div className="modal inmodal">
        <div className="modal-dialog">
          <div className="modal-content animated fadeIn">
          <Modal
            isOpen={this.props.isOpen}
            onRequestClose={this.props.onRequestClose}
            style={{
              content : {
                position : 'null',
                top : 'null',
                left : 'null',
                right : 'null',
                bottom : 'null',
                border : 'none',
                background : '#fff',
                padding : 'null',
                maxWidth : '50%',
                minWidth : '350px'
              },
              overlay : {
                position : 'fixed',
                top : 0,
                left : 0,
                right : 0,
                bottom : 0,
                display : 'flex',
                alignItems : 'center',
                justifyContent : 'center',
                backgroundColor : 'rgba(0,0,0,00.1)',
                zIndex:2500
              },
            }}
          >
            {this.state.isLoading ?
              <div className="ibox-content sk-loading position-static">
                <div className="sk-spinner sk-spinner-fading-circle">
                  <div className="sk-circle1 sk-circle"></div>
                  <div className="sk-circle2 sk-circle"></div>
                  <div className="sk-circle3 sk-circle"></div>
                  <div className="sk-circle4 sk-circle"></div>
                  <div className="sk-circle5 sk-circle"></div>
                  <div className="sk-circle6 sk-circle"></div>
                  <div className="sk-circle7 sk-circle"></div>
                  <div className="sk-circle8 sk-circle"></div>
                  <div className="sk-circle9 sk-circle"></div>
                  <div className="sk-circle10 sk-circle"></div>
                  <div className="sk-circle11 sk-circle"></div>
                  <div className="sk-circle12 sk-circle"></div>
                </div>
              </div>
            :
            <>
              <div className="modal-header d-block text-center text-darkblue">
                <button className="close" onClick={this.props.onRequestClose}><span>×</span></button>
                <h4 className="modal-title">{this.props.modalTitle}</h4>
                <h5 className="font-normal">{this.props.modalDescription}</h5>
              </div>
              <div className="modal-body text-darkblue">
                <strong>Sorgu Tarihi<strong className="text-danger ml-1">*</strong></strong>
								<input className="form-control form-input  mb-2 mt-1" onChange={event => { this.setState(prevState => ({ damageHistory: { ...prevState.damageHistory, queryDate: event.target.value}}));}} onKeyDown={this.handleKeyPress} type="date" value={this.state.damageHistory.queryDate} />
                <strong>Tramer Ücreti<strong className="text-danger ml-1">*</strong></strong>
								<input className="form-control form-input mb-1" onChange={event => { const filtered = event.target.value.replace(/[^0-9.,]/g, ''); this.setState(prevState => ({ damageHistory: { ...prevState.damageHistory, amount: filtered }}));}} onKeyDown={this.handleKeyPress} placeholder="Tramer Ücreti" type="text" value={this.state.damageHistory.amount} />
                <strong>Tramer Tarihi<strong className="text-danger ml-1">*</strong></strong>
								<input className="form-control form-input  mb-2 mt-1" onChange={event => { this.setState(prevState => ({ damageHistory: { ...prevState.damageHistory, date: event.target.value}}));}} onKeyDown={this.handleKeyPress} type="date" value={this.state.damageHistory.date} />
                <strong>Tramer Açıklaması<strong className="text-danger ml-1">*</strong></strong>
								<textarea className="form-control form-input mb-1" onChange={event => { this.setState(prevState => ({ damageHistory: { ...prevState.damageHistory, comment: event.target.value}}));}} onKeyDown={this.handleKeyPress} placeholder="Tramer Açıklaması" type="text" value={this.state.damageHistory.comment} />
              </div>
              <div className="modal-footer">
                <button className="btn btn-orange" onClick={() => this.saveOnClick()}>Kaydet</button>
              </div>
            </>
            }
          </Modal>
          </div>
        </div>
      </div>
    )
  }
}